<!-- Added automation IDs 19/10/2026 DW -->
<div class="horizontal-sidebar p-y-8 b-b-1">
  <div class="container-fluid horizontal-sidebar__container">
    <div class="d-flex align-items-center w-100 horizontal-sidebar__row">
      <div class="horizontal-sidebar__side horizontal-sidebar__side--left">
        <div class="horizontal-sidebar__branding d-flex align-items-center flex-shrink-0">
          <app-branding></app-branding>
        </div>
      </div>
      @if (mobileQuery.matches) {
        <div class="horizontal-sidebar__nav-wrap">
          <div class="horizontal-navbar hstack align-items-center flex-wrap gap-0">
            @for (item of navItems; track item) {
              <app-horizontal-nav-item
                [item]="item"
                class="parentBox {{ item.ddType }}"
                [ngClass]="{
                pactive: isParentActive(item)
                }"
                >
              </app-horizontal-nav-item>
            }
          </div>
        </div>
      }
      <div class="horizontal-sidebar__side horizontal-sidebar__side--right">
        <div class="horizontal-sidebar__profile d-flex align-items-center flex-shrink-0">
        <!-- Standard 3-stripe menu button for profile menu 22/07/2026 DW -->
        <button id="shell-menu-icon-btn"
          mat-icon-button
          [matMenuTriggerFor]="profilemenu"
          aria-label="Menu"
          class="d-flex justify-content-center">
          <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
        </button>
        <mat-menu
          #profilemenu="matMenu"
          xPosition="before"
          class="topbar-dd cardWithShadow"
        >
          <div class="p-y-12 p-x-32">
            <a id="shell-auth-service-link"
              (click)="authService.logout()"
              mat-raised-button
              color="accent"
              class="w-100">Logout</a
            >
          </div>
          
          <div class="p-y-12 p-x-32">
            <a id="shell-action-link"
              [routerLink]="['/user/profile']"
              mat-raised-button
              color="primary"
              class="w-100">Profile</a
            >
          </div>
        </mat-menu>
        </div>
      </div>
    </div>
  </div>
</div>
